const bindings = new Map();

function attachSizeCharts() {
  for (const [owner, binding] of bindings) {
    if (!owner.isConnected || !owner.hasAttribute('data-size-chart-inline')) {
      binding.proxy.remove();
      bindings.delete(owner);
    }
  }
  document.querySelectorAll('[data-size-chart-inline]').forEach((owner) => {
    const scope = owner.closest('.product-details') || owner.closest('.shopify-section');
    const slots = scope ? [...scope.querySelectorAll('variant-picker [data-size-chart-slot]')] : [];
    const slot = slots[0];
    const trigger = owner.querySelector('.size-chart-block__trigger');
    const previous = bindings.get(owner);
    if (!slot || !trigger) {
      previous?.proxy.remove();
      owner.removeAttribute('data-size-chart-embedded');
      bindings.delete(owner);
      return;
    }
    if (previous?.proxy.isConnected && previous.slot === slot) return;
    previous?.proxy.remove();
    if (slot.querySelector('[data-size-chart-proxy]')) return;
    const proxy = trigger.cloneNode(true);
    proxy.removeAttribute('on:click');
    proxy.removeAttribute('id');
    proxy.removeAttribute('ref');
    proxy.dataset.sizeChartProxy = '';
    proxy.classList.add('size-chart-block__trigger--inline');
    const color = getComputedStyle(trigger).color;
    proxy.style.setProperty('--size-chart-inline-color', color);
    proxy.addEventListener('click', () => trigger.click());
    slot.append(proxy);
    slot.closest('[data-size-chart-heading]')?.classList.add('variant-option__chart-heading');
    owner.setAttribute('data-size-chart-embedded', '');
    bindings.set(owner, { proxy, slot });
  });
}

let pending = false;
function scheduleSizeCharts() {
  if (pending) return;
  pending = true;
  requestAnimationFrame(() => {
    pending = false;
    attachSizeCharts();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleSizeCharts, { once: true });
} else {
  scheduleSizeCharts();
}
new MutationObserver(scheduleSizeCharts).observe(document.documentElement, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', scheduleSizeCharts);
